import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { ButtonNew } from '../ButtonNew';
import CustomLink from '../CustomLink';
import { useRouting } from '../../shared/use-routing';
import { pagePathnames } from '../../pages/page-routes';
import { uiConfig } from '../../app-ui-config';
import { disableScroll, enableScroll } from '../../shared/scroll';
import styles from './MobileMenu.css';

const cx = classnames.bind(styles);

function MobileMenu({ isOpen, onClose }) {
    const { buildPath } = useRouting();
    const { t } = useTranslation();

    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        disableScroll();

        return () => {
            enableScroll();
        };
    }, [isOpen]);

    return (
        <div
            className={cx('root', { open: isOpen })}
            aria-hidden={!isOpen}
        >
            <nav className={styles.nav} aria-label={t('common.mainNavigation')}>
                <CustomLink
                    to={buildPath(`${pagePathnames.start}#reviews`)}
                    className={styles.navLink}
                    onClick={onClose}
                >
                    {t('common.reviews')}
                </CustomLink>
                <CustomLink
                    to={buildPath(`${pagePathnames.start}#faq`)}
                    className={styles.navLink}
                    onClick={onClose}
                >
                    {t('common.faq')}
                </CustomLink>
                <CustomLink
                    to={buildPath(pagePathnames.aboutUs)}
                    className={styles.navLink}
                    onClick={onClose}
                >
                    {t('common.aboutUs')}
                </CustomLink>
                <CustomLink
                    to={buildPath(pagePathnames.contactUs)}
                    className={styles.navLink}
                    onClick={onClose}
                >
                    {t('common.contactUsLink')}
                </CustomLink>
            </nav>
            <div className={styles.actions}>
                <ButtonNew
                    type='text'
                    className={styles.actionButton}
                    label={t('common.signIn')}
                    onClick={onClose}
                    link={{ to: buildPath(pagePathnames.signIn) }}
                />
                <ButtonNew
                    type='pill'
                    className={styles.actionButton}
                    label={t('common.getStarted')}
                    onClick={onClose}
                    link={{
                        to: uiConfig.prelanderLink,
                        target: '_blank'
                    }}
                />
            </div>
        </div>
    );
}

MobileMenu.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func.isRequired
};

MobileMenu.defaultProps = {
    isOpen: false
};

export {
    MobileMenu
};
